import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { EmailTemplate }    from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "EMAIL_TEMPLATE_LOADING" });
    },

    /**
     * Fetches the Email Template List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await EmailTemplate.getAll(params);
        data.sort = params;
        dispatch({ type : "EMAIL_TEMPLATE_LIST", data });
    },

    /**
     * Fetches a single Email Template
     * @param {Function} dispatch
     * @param {Number}   templateID
     * @returns {Promise}
     */
    async fetchElem(dispatch, templateID) {
        const data = await EmailTemplate.getOne({ templateID });
        dispatch({ type : "EMAIL_TEMPLATE_ELEM", data });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.messageHtml = elem.message.replace(/\n/g, "<br>");
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "EMAIL_TEMPLATE_LIST", "EMAIL_TEMPLATE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "EMAIL_TEMPLATE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "EMAIL_TEMPLATE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "EMAIL_TEMPLATE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
